export function isNil(value) {
  return isUndefined(value) || isNull(value);
}

export function isUndefined(value) {
  return value === undefined;
}

export function isNull(value) {
  return value === null;
}

export function isArray(value) {
  return Object.prototype.toString.call(value) === '[object Array]';
}

export function isObject(value) {
  return Object.prototype.toString.call(value) === '[object Object]';
}

export function isEmptyArray(value) {
  return isArray(value) && value.length === 0;
}

export function isEmptyObject(value) {
  return isObject(value) && Object.keys(value).length === 0;
}
